import http from '@/components/new/common/httpRequest/http'

const state = () => ({
  permissionList: [] // 权限列表
})

const getters = {}

const actions = {
  getPermissionList({ commit }, routes) {
    // 创建一个路由总容器
    let routeContainerChildren = []
    // 模拟后端接口数据请求
    return new Promise((resolve) => {
      http("/api/menu/queryTreeByRole").then((res) => {
        let requestPermission = res.data.data
        if(!requestPermission) return
        // 获取一级菜单
        for (let index = 0; index < requestPermission.length; index++) {
          let routeObj = {}
          const element = requestPermission[index];
          if(element.children && element.children.length) {
            let parentContainer = routes.parentContainer[element.key]
            let tempChildren = []
            if(parentContainer) {
              element.children.map(item => {
                let childrenContainer = parentContainer.childrenContainer && parentContainer.childrenContainer[item.key]
                if(childrenContainer) {
                  tempChildren.push({
                    ...childrenContainer,
                    title: item.title
                  })
                }
              })
              // redirect 拼接重定向路由
              routeObj = {...parentContainer, redirect: `${parentContainer.path}/${tempChildren[0].path}`, children: tempChildren, title: element.title}
              delete routeObj.childrenContainer
              routeContainerChildren.push(routeObj)
            }
          }
        }
        let children = [...routeContainerChildren, ...routes.notParentContainer]
        let permissionRoutes = [{...routes.container, children, redirect: children.length && children[0].path }]
        commit('SET_PERMISSION_LIST', routeContainerChildren)
        resolve(permissionRoutes)
      });
    })
  }
}

const mutations = {
  SET_PERMISSION_LIST(state, list = []) {
    state.permissionList = list
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}